
      <custom-super-tabs-toolbar [tabsPlacement]="tabsPlacement" [hidden]="!_isToolbarVisible" [config]="config"
                          [color]="toolbarBackground"
                          [tabsColor]="toolbarColor" [indicatorColor]="indicatorColor" [badgeColor]="badgeColor"
                          [scrollTabs]="scrollTabs"
                          [selectedTab]="selectedTabIndex"
                          (tabSelect)="onToolbarTabSelect($event)"></custom-super-tabs-toolbar>
      <custom-super-tabs-container [config]="config" [tabsCount]="_tabs.length" [selectedTabIndex]="selectedTabIndex"
                            (tabSelect)="onContainerTabSelect($event)" (onDrag)="onDrag()">
      <ng-content></ng-content>
  </custom-super-tabs-container>
    